var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirst10410061(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2226_1766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3455 19.4111L6.56396 30.4365L3.60202 30.7733C3.09924 30.8304 2.73727 30.3019 2.97223 29.8538L9.28863 17.8081L12.3455 19.4111Z",
    fill: "url(#paint0_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4021 21.0136L9.62072 32.0392L8.83835 30.5776C8.7164 30.3498 8.46777 30.2194 8.21102 30.2486L6.56396 30.4362L12.3454 19.4106L15.4021 21.0136Z",
    fill: "url(#paint1_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.459 22.6166L12.1426 34.6622C11.9077 35.1104 11.2671 35.1132 11.0282 34.6671L9.62085 32.0392L15.4023 21.0137L18.459 22.6166Z",
    fill: "url(#paint2_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87939 26.0207L10.3333 30.6804L15.4023 21.0135L12.3456 19.4106L8.87939 26.0207Z",
    fill: "url(#paint3_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3455 19.4111L8.87954 26.0208L7.42554 21.3612L9.28867 17.8081L12.3455 19.4111Z",
    fill: "url(#paint4_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6545 19.4111L28.436 30.4365L31.3979 30.7733C31.9007 30.8304 32.2627 30.3019 32.0277 29.8538L25.7113 17.8081L22.6545 19.4111Z",
    fill: "url(#paint5_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5977 21.0136L25.3791 32.0392L26.1615 30.5776C26.2834 30.3498 26.532 30.2194 26.7888 30.2486L28.4358 30.4362L22.6544 19.4106L19.5977 21.0136Z",
    fill: "url(#paint6_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.541 22.6166L22.8574 34.6622C23.0924 35.1104 23.733 35.1132 23.9719 34.6671L25.3792 32.0392L19.5978 21.0137L16.541 22.6166Z",
    fill: "url(#paint7_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1206 26.0207L24.6668 30.6804L19.5977 21.0135L22.6545 19.4106L26.1206 26.0207Z",
    fill: "url(#paint8_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6545 19.4111L26.1205 26.0208L29.0723 24.2733L25.7113 17.8081L22.6545 19.4111Z",
    fill: "url(#paint9_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6108 13.5979L28.6208 15.932C28.4117 16.1773 28.3083 16.4955 28.3333 16.817L28.5716 19.8748C28.6181 20.4718 28.2238 21.0141 27.6416 21.154L24.6596 21.8705C24.3454 21.946 24.0741 22.1433 23.9053 22.4188L22.3044 25.0328C21.9913 25.5442 21.3527 25.7516 20.7988 25.522L17.9668 24.3474C17.668 24.2235 17.3322 24.2235 17.0334 24.3474L14.2013 25.5218C13.6474 25.7515 13.0088 25.544 12.6956 25.0327L11.0948 22.4187C10.926 22.1431 10.6547 21.9459 10.3405 21.8704L7.35854 21.1539C6.77633 21.0139 6.38203 20.4716 6.42858 19.8746L6.66682 16.817C6.69184 16.4956 6.58848 16.1773 6.3793 15.932L4.38936 13.598C4.00107 13.1425 4.00107 12.4726 4.38936 12.0171L6.3793 9.68309C6.58848 9.43774 6.69184 9.11953 6.66682 8.79804L6.42858 5.74025C6.38203 5.14327 6.77633 4.60098 7.35854 4.46104L10.3405 3.7445C10.6547 3.66903 10.926 3.47175 11.0949 3.19619L12.6957 0.582196C13.0089 0.0708681 13.6475 -0.136602 14.2013 0.093085L17.0334 1.26757C17.3322 1.3915 17.668 1.3915 17.9668 1.26757L20.799 0.0931534C21.3528 -0.136534 21.9914 0.0709365 22.3046 0.582265L23.9054 3.19626C24.0742 3.47188 24.3455 3.6691 24.6597 3.74457L27.6417 4.46111C28.2239 4.60104 28.6182 5.14334 28.5716 5.74032L28.3334 8.79797C28.3084 9.11939 28.4117 9.43767 28.6209 9.68302L30.6108 12.017C30.9991 12.4724 30.9991 13.1425 30.6108 13.5979Z",
    fill: "url(#paint10_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6108 13.5981C30.7006 13.4928 30.7687 13.3757 30.817 13.2527L24.1187 6.55446C22.4583 4.7977 20.1081 3.69971 17.5 3.69971C12.4699 3.69971 8.39209 7.77748 8.39209 12.8076C8.39209 15.4157 9.49008 17.7659 11.2468 19.4263L16.4218 24.6013L17.0334 24.3476C17.3322 24.2237 17.668 24.2237 17.9668 24.3476L20.7988 25.522C21.3527 25.7517 21.9913 25.5442 22.3045 25.0329L23.9053 22.4189C24.0741 22.1433 24.3454 21.9461 24.6596 21.8706L27.6415 21.154C28.2238 21.0141 28.6181 20.4718 28.5715 19.8748L28.3333 16.8171C28.3083 16.4956 28.4116 16.1773 28.6208 15.932L30.6108 13.5981Z",
    fill: "url(#paint11_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.9156C22.5304 21.9156 26.6082 17.8377 26.6082 12.8074C26.6082 7.7771 22.5304 3.69922 17.5 3.69922C12.4697 3.69922 8.39185 7.7771 8.39185 12.8074C8.39185 17.8377 12.4697 21.9156 17.5 21.9156Z",
    fill: "url(#paint12_linear_2226_1766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.324 10.148V8.24H18.648V17H16.512V10.148H15.324Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2226_1766",
    x1: 5.78693,
    y1: 28.2024,
    x2: 11.5453,
    y2: 17.2202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ECCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA9F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2226_1766",
    x1: 10.9768,
    y1: 25.7366,
    x2: 14.8768,
    y2: 18.3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2EDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FC7E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2226_1766",
    x1: 13.4818,
    y1: 28.3919,
    x2: 19.4145,
    y2: 17.0789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D54003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2226_1766",
    x1: 9.58015,
    y1: 28.4004,
    x2: 12.8008,
    y2: 22.2584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FC7E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2226_1766",
    x1: 7.32778,
    y1: 25.2639,
    x2: 8.77579,
    y2: 22.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F88C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2226_1766",
    x1: 29.2123,
    y1: 28.2017,
    x2: 23.4532,
    y2: 17.2202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ECCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA9F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2226_1766",
    x1: 24.0221,
    y1: 25.7363,
    x2: 20.1228,
    y2: 18.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2EDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FC7E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2226_1766",
    x1: 21.5174,
    y1: 28.3916,
    x2: 15.5847,
    y2: 17.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D54003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2226_1766",
    x1: 25.4193,
    y1: 28.4003,
    x2: 22.198,
    y2: 22.2576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FC7E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4975AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2226_1766",
    x1: 27.0362,
    y1: 24.0518,
    x2: 25.5882,
    y2: 21.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F88C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2226_1766",
    x1: 11.2498,
    y1: 6.55794,
    x2: 33.2211,
    y2: 28.5299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDA34F",
    stopOpacity: 0.958352
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDA34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2226_1766",
    x1: 27.3522,
    y1: 22.6607,
    x2: 17.444,
    y2: 12.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D54003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2226_1766",
    x1: 13.2044,
    y1: 8.51263,
    x2: 28.3049,
    y2: 23.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#FFBF5C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2226_1766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst10410061);
export default __webpack_public_path__ + "static/media/first_1041006 1.28a759eb09dd87069bcd309f61c0e6d2.svg";
export { ForwardRef as ReactComponent };